module.exports = {
	"id" : "KYC",
	"name" : "KYC",
	"page" : 4,
	"rules" : [
		{
			"conditions" : {
				"consentToShareInfor" : {
					"is" : false
				}
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : [
						"ConsentContact-FirstName",
						"ConsentContact-LastName",
						"ConsentContact-Relationship",
						"ConsentContact-Email",
						"ConsentContact-MailingStreet",
						"ConsentContact-MailingCity",
						"ConsentContact-MailingState",
						"ConsentContact-MailingPostalCode",
						"ConsentContact-MailingCountry",
						"ConsentContact-OnlineAccess",
						"ConsentContact-QuarterlyReporting",
						"ConsentContact-TaxReporting",
						"ConsentContact-FeeReceipts",
						"ConsentContact-AccountInformation",
						"ConsentContact-PreferredMethodOfDelivery"
					]
				}
			}
		},
		{
			"conditions" : {
				"or" : [
					{
						"Contact-FinServ__MaritalStatus__c" : {
							"or" : [
								{
									"is" : "Single"
								},
								{
									"is" : "Separated"
								},
								{
									"is" : "Divorced"
								},
								{
									"is" : "Widowed"
								}
							]
						}
					},
					{
						"Account-Is_Spouse_a_Mawer_Client__c" : {
							"is" : false
						}
					}
				]
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : [
						"spousalAuthorizationToProvideInstructions",
						"spousalAuthorizationToProvideInstructionsText1",
						"spousalAuthorizationToProvideInstructionsText2",
						"spousalAuthorizationToProvideInstructionsText3",
						"spousalAuthorizationToProvideInstructionsText4",
						"spousalAuthorizationToProvideInstructionsText5",
						"spousalAuthorizationToProvideInstructionsText6",
						"Account-Spouse_Provide_Instructions__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"and" : [
					{
						"Contact-FinServ__MaritalStatus__c" : {
							"or" : [
								{
									"is" : "Married"
								},
								{
									"is" : "Common-Law"
								}
							]
						}
					},
					{
						"Account-Is_Spouse_a_Mawer_Client__c" : {
							"is" : true
						}
					}
				]
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Account-Spouse_Provide_Instructions__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"consentToShareInfor" : {
					"is" : true
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"ConsentContact-FirstName",
						"ConsentContact-LastName",
						"ConsentContact-Relationship",
						"ConsentContact-Email",
						"ConsentContact-MailingStreet",
						"ConsentContact-MailingCity",
						"ConsentContact-MailingState",
						"ConsentContact-MailingPostalCode",
						"ConsentContact-MailingCountry",
						"ConsentContact-OnlineAccess",
						"ConsentContact-QuarterlyReporting",
						"ConsentContact-TaxReporting",
						"ConsentContact-FeeReceipts",
						"ConsentContact-AccountInformation",
						"ConsentContact-PreferredMethodOfDelivery"
					]
				}
			}
		}
	],
	"uiSchema" : {
		"Contact-FinServ__MaritalStatus__c" : {
			"ui:widget" : "hidden"
		},
		"Account-Is_Spouse_a_Mawer_Client__c" : {
			"ui:widget" : "hidden"
		},
		"informationDistribution" : {
			"header" : "Information Distribution",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"Account-Setup_Portal_Access__c" : {
			"ui:widget" : "radio"
		},
		"spousalAuthorizationToProvideInstructions" : {
			"header" : "Spousal Authorization to Provide Instructions",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"spousalAuthorizationToProvideInstructionsText2" : {
			"wrapperClassNames" : "col-xs-2 col-md-2"
		},
		"spousalAuthorizationToProvideInstructionsText3" : {
			"wrapperClassNames" : "col-xs-10 col-md-10"
		},
		"spousalAuthorizationToProvideInstructionsText4" : {
			"wrapperClassNames" : "col-xs-2 col-md-2"
		},
		"spousalAuthorizationToProvideInstructionsText5" : {
			"wrapperClassNames" : "col-xs-10 col-md-10"
		},
		"Account-Spouse_Provide_Instructions__c" : {
			"ui:widget" : "radio"
		},
		"consentToShareYourInformationHeader" : {
			"header" : "Consent to Share Your Information",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"consentToShareInfor" : {
			"ui:widget" : "radio"
		},
		"ConsentContact-FirstName" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-LastName" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-Relationship" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-Email" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-MailingStreet" : {
			"wrapperClassNames" : "col-xs-8 col-md-8",
			"ui:widget" : "addressInput"
		},
		"ConsentContact-MailingCity" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-MailingState" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-MailingPostalCode" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-MailingCountry" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-OnlineAccess" : {
			"ui:widget" : "radio",
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-QuarterlyReporting" : {
			"ui:widget" : "radio",
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-TaxReporting" : {
			"ui:widget" : "radio",
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-FeeReceipts" : {
			"ui:widget" : "radio",
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-AccountInformation" : {
			"ui:widget" : "radio",
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"ConsentContact-PreferredMethodOfDelivery" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		}
	},
	"schema" : {
		"required" : [
			"Account-Statement_Delievery__c",
			"consentToShareInfor",
			"Account-Setup_Portal_Access__c"
		],
		"title" : "Managing Your Account(s)",
		"type" : "object",
		"root" : true,
		"properties" : {
			"Contact-FinServ__MaritalStatus__c" : {
				"type" : "string"
			},
			"Account-Is_Spouse_a_Mawer_Client__c" : {
				"type" : "boolean"
			},
			"informationDistribution" : {
				"type" : "string"
			},
			"Account-Setup_Portal_Access__c" : {
				"title" : "Would you like access to the Mawer client portal, where you can view your account information online and receive electronic statement reporting for your accounts?",
				"$ref" : "#/definitions/boolCheckbox",
				"default" : true
			},
			"Account-Statement_Delievery__c" : {
				"title" : "How would you like to receive your quarterly statements?",
				"enum" : [
					"Electronic",
					"Hard Copy"
				],
				"type" : "string",
				"default": "Electronic"
			},
			"spousalAuthorizationToProvideInstructions" : {
				"type" : "string"
			},
			"spousalAuthorizationToProvideInstructionsText1" : {
				"title" : "You may authorize the Manager to accept instructions relating to your Account(s) from your spouse who is also a client of Mawer, and that such instructions shall be valid and binding on your Account(s). The Manager may provide access to your Account Information and accept certain Account instructions as follows:",
				"type" : "null"
			},
			"spousalAuthorizationToProvideInstructionsText2" : {
				"title" : "Information Access:",
				"type" : "null"
			},
			"spousalAuthorizationToProvideInstructionsText3" : {
				"title" : "Online access to view your Account(s), receive client reporting, tax reporting, fee receipts, and other Account information.",
				"type" : "null"
			},
			"spousalAuthorizationToProvideInstructionsText4" : {
				"title" : "Account Instructions:",
				"type" : "null"
			},
			"spousalAuthorizationToProvideInstructionsText5" : {
				"title" : "Provide trade instructions, transfer assets between your Account(s), withdrawal of funds and transfer to your bank account (no change in beneficial ownership), authorize management fee payments.",
				"type" : "null"
			},
			"Account-Spouse_Provide_Instructions__c" : {
				"title" : "Do you consent to the above? NOTE: This does not grant Power of Attorney over your Account(s). You acknowledge that you may withdraw this consent and authorization at any time.",
				"$ref" : "#/definitions/boolCheckbox",
				"default" : false
			},
			"spousalAuthorizationToProvideInstructionsText6" : {
				"title" : "NOTE: If you wish to grant your spouse VIEW ONLY access, with no authority to instruct on your accounts, please select 'No' to the above and complete your spouse's details in the section 'Consent to Share Your Information' directly below.",
				"type" : "null"
			},
			"consentToShareYourInformationHeader" : {
				"type" : "string"
			},
			"consentToShareInfor" : {
				"title" : "You may wish to allow us to discuss your Account(s) and investments or share copies of reporting and other information with another person (e.g. a family member) or with a professional advisor (e.g., tax, financial planning, audit, estate, etc.). We respect the privacy of our clients and will not share any information about you or your investments unless we have your specific consent to share information with that individual. Providing this consent only allows the sharing of information, it DOES NOT allow the other person to give instructions on your Account(s) or direct any transactions, trades or withdrawals from your Account(s).",
				"$ref" : "#/definitions/boolCheckbox",
				"default" : false
			},
			"ConsentContact-FirstName" : {
				"title" : "First Name",
				"type" : "string"
			},
			"ConsentContact-LastName" : {
				"title" : "Last Name",
				"type" : "string"
			},
			"ConsentContact-Relationship" : {
				"title" : "Relationship",
				"$ref" : "#/definitions/relationships"
			},
			"ConsentContact-Email" : {
				"title" : "Email",
				"type" : "string"
			},
			"ConsentContact-MailingStreet" : {
				"title" : "Primary Address",
				"type" : "string"
			},
			"ConsentContact-MailingCity" : {
				"title" : "City",
				"type" : "string"
			},
			"ConsentContact-MailingState" : {
				"title" : "State",
				"type" : "string"
			},
			"ConsentContact-MailingPostalCode" : {
				"title" : "Postal Code",
				"type" : "string"
			},
			"ConsentContact-MailingCountry" : {
				"title" : "Country",
				"$ref" : "#/definitions/countries"
			},
			"ConsentContact-OnlineAccess" : {
				"title" : "Online Access",
				"$ref" : "#/definitions/yesNoCheckbox"
			},
			"ConsentContact-QuarterlyReporting" : {
				"title" : "Quarterly Reporting",
				"$ref" : "#/definitions/yesNoCheckbox"
			},
			"ConsentContact-TaxReporting" : {
				"title" : "Tax Reporting",
				"$ref" : "#/definitions/yesNoCheckbox"
			},
			"ConsentContact-FeeReceipts" : {
				"title" : "Fee Receipts",
				"$ref" : "#/definitions/yesNoCheckbox"
			},
			"ConsentContact-AccountInformation" : {
				"title" : "Account Information",
				"$ref" : "#/definitions/yesNoCheckbox"
			},
			"ConsentContact-PreferredMethodOfDelivery" : {
				"title" : "Preferred Method of Delivery",
				"enum" : [
					"Electronic",
					"Hard Copy"
				],
				"type" : "string"
			}
		},
		"definitions" : {
			"boolCheckbox" : {
				"type" : "boolean",
				"oneOf" : [
					{
						"const" : true,
						"title" : "Yes"
					},
					{
						"const" : false,
						"title" : "No"
					}
				]
			},
			"yesNoCheckbox" : {
				"type" : "string",
				"oneOf" : [
					{
						"const" : "Yes",
						"title" : "Yes"
					},
					{
						"const" : "No",
						"title" : "No"
					}
				]
			},
			"relationships" : {
				"title" : "Relationship",
				"type" : "string",
				"enum" : [
					"Custodian",
					"Consultant",
					"Planner",
					"Advisor",
					"Extended Family",
					"Trustee",
					"Common-law Partner",
					"Spouse",
					"Ex-Spouse",
					"Power of Attorney",
					"Sibling",
					"Child",
					"Grandchild",
					"Grandparent",
					"Accountant",
					"Lawyer",
					"Parent",
					"Executive Assistant",
					"Trusted Contact Person",
					"Advocate"
				]
			},
			"countries" : {
				"title" : "Country",
				"type" : "string",
				"enum" : [
					"Afghanistan",
					"Albania",
					"Algeria",
					"Andorra",
					"Angola",
					"Anguilla",
					"Antigua &amp; Barbuda",
					"Argentina",
					"Armenia",
					"Aruba",
					"Australia",
					"Austria",
					"Azerbaijan",
					"Bahamas",
					"Bahrain",
					"Bangladesh",
					"Barbados",
					"Belarus",
					"Belgium",
					"Belize",
					"Benin",
					"Bermuda",
					"Bhutan",
					"Bolivia",
					"Bosnia &amp; Herzegovina",
					"Botswana",
					"Brazil",
					"British Virgin Islands",
					"Brunei",
					"Bulgaria",
					"Burkina Faso",
					"Burundi",
					"Cambodia",
					"Cameroon",
					"Canada",
					"Cape Verde",
					"Cayman Islands",
					"Chad",
					"Chile",
					"China",
					"Colombia",
					"Congo",
					"Cook Islands",
					"Costa Rica",
					"Cote D Ivoire",
					"Croatia",
					"Cruise Ship",
					"Cuba",
					"Cyprus",
					"Czech Republic",
					"Denmark",
					"Djibouti",
					"Dominica",
					"Dominican Republic",
					"Ecuador",
					"Egypt",
					"El Salvador",
					"Equatorial Guinea",
					"Estonia",
					"Ethiopia",
					"Falkland Islands",
					"Faroe Islands",
					"Fiji",
					"Finland",
					"France",
					"French Polynesia",
					"French West Indies",
					"Gabon",
					"Gambia",
					"Georgia",
					"Germany",
					"Ghana",
					"Gibraltar",
					"Greece",
					"Greenland",
					"Grenada",
					"Guam",
					"Guatemala",
					"Guernsey",
					"Guinea",
					"Guinea Bissau",
					"Guyana",
					"Haiti",
					"Honduras",
					"Hong Kong",
					"Hungary",
					"Iceland",
					"India",
					"Indonesia",
					"Iran",
					"Iraq",
					"Ireland",
					"Isle of Man",
					"Israel",
					"Italy",
					"Jamaica",
					"Japan",
					"Jersey",
					"Jordan",
					"Kazakhstan",
					"Kenya",
					"Kuwait",
					"Kyrgyz Republic",
					"Laos",
					"Latvia",
					"Lebanon",
					"Lesotho",
					"Liberia",
					"Libya",
					"Liechtenstein",
					"Lithuania",
					"Luxembourg",
					"Macau",
					"Macedonia",
					"Madagascar",
					"Malawi",
					"Malaysia",
					"Maldives",
					"Mali",
					"Malta",
					"Mauritania",
					"Mauritius",
					"Mexico",
					"Moldova",
					"Monaco",
					"Mongolia",
					"Montenegro",
					"Montserrat",
					"Morocco",
					"Mozambique",
					"Namibia",
					"Nepal",
					"Netherlands",
					"Netherlands Antilles",
					"New Caledonia",
					"New Zealand",
					"Nicaragua",
					"Niger",
					"Nigeria",
					"Norway",
					"Oman",
					"Pakistan",
					"Palestine",
					"Panama",
					"Papua New Guinea",
					"Paraguay",
					"Peru",
					"Philippines",
					"Poland",
					"Portugal",
					"Puerto Rico",
					"Qatar",
					"Reunion",
					"Romania",
					"Russia",
					"Rwanda",
					"Saint Pierre &amp; Miquelon",
					"Samoa",
					"San Marino",
					"Satellite",
					"Saudi Arabia",
					"Senegal",
					"Serbia",
					"Seychelles",
					"Sierra Leone",
					"Singapore",
					"Slovakia",
					"Slovenia",
					"South Africa",
					"South Korea",
					"Spain",
					"Sri Lanka",
					"St Kitts &amp; Nevis",
					"St Lucia",
					"St Vincent",
					"St. Lucia",
					"Sudan",
					"Suriname",
					"Swaziland",
					"Sweden",
					"Switzerland",
					"Syria",
					"Taiwan",
					"Tajikistan",
					"Tanzania",
					"Thailand",
					"Timor L'Este",
					"Togo",
					"Tonga",
					"Trinidad &amp; Tobago",
					"Tunisia",
					"Turkey",
					"Turkmenistan",
					"Turks &amp; Caicos",
					"Uganda",
					"Ukraine",
					"United Arab Emirates",
					"United Kingdom",
					"United States",
					"United States Minor Outlying Islands",
					"Uruguay",
					"Uzbekistan",
					"Venezuela",
					"Vietnam",
					"Virgin Islands (US)",
					"Yemen",
					"Zambia",
					"Zimbabwe"
				]
			}
		}
	}
}